module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "records-table"
  }, [_c('div', {
    staticClass: "table-toolbar"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('FormulateInput', {
    attrs: {
      "type": "search"
    },
    on: {
      "input": _vm.tableSearch
    },
    model: {
      value: (_vm.query),
      callback: function($$v) {
        _vm.query = $$v
      },
      expression: "query"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "right text-right"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.download
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "wrapper small",
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover table-striped contacts-queue-table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.tableData.header), function(item, $index) {
    return _c('th', [_vm._v("\n                      " + _vm._s(item.label) + "\n                    ")])
  })], 2)]), _vm._v(" "), _c('tbody', [(_vm.tableData.count == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": _vm.tableData.header.length + 1
    }
  }, [_c('i', [_vm._v("No results")])])]) : _vm._l((_vm.tableData.results), function(row, $rowIndex) {
    return _c('tr', {
      key: row.id
    }, [_c('td', [_c('a', {
      staticClass: "btn",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showRecord(row.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info"
    })])]), _vm._v(" "), _vm._l((_vm.tableData.header), function(column, $columnIndex) {
      return _c('table-cell', {
        key: $rowIndex + '-' + $columnIndex,
        attrs: {
          "value": row[column.name],
          "valueType": column.type,
          "childValueType": column.child_type
        }
      })
    })], 2)
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "ls-table-pagination"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.tableData.previous
    },
    on: {
      "click": _vm.prevPage
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" prev")]), _vm._v(" |\n              "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.tableData.next
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_vm._v("next "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })]), _vm._v(" "), _c('span', [_vm._v("Records: "), _c('b', [_vm._v(_vm._s(_vm.tableData.count))])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38692506"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/RecordsTable.vue
// module id = 640
// module chunks = 0